import React, { Component } from 'react';

class BasePage extends Component {

    render() {
        return (
            <div className="wrapper">
                {this.props.children}
            </div>
        );
    }

}

export default BasePage;



// WEBPACK FOOTER //
// ./master/jsx/components/Layout/BasePage.jsx